





























import {Component, Vue} from 'vue-property-decorator';
import * as microtime from '@/lib/microtime';

@Component
export default class Knobs extends Vue {
    littleEndian: boolean = true;
    minTime: number = Date.UTC(new Date().getUTCFullYear() - 1, 0, 1) * 1000;
    maxTime: number = Date.UTC(new Date().getUTCFullYear() + 1, 0, 1) * 1000;
    minTimeInput: string = microtime.toISOString(this.minTime);
    maxTimeInput: string = microtime.toISOString(this.maxTime);

    setLittleEndian(littleEndian: boolean) {
        this.littleEndian = littleEndian;
    }

    setMinTime() {
    }

    setMaxTime() {
    }
}
